import { actionType } from "./typeAction";
const initMovie = {
    Movie: [],
    MovieDetail: [],
    Catagory: [],
    searchMV: [],
    browserMovies: [],
    loading: true,
    LoadingBrowse: true,
    LoadingSearch: true,
    header: false,
    ErrorMessage: '',
    SimilarMV: []
}
export const MovieHomePage = (state = initMovie, { type, payload }) => {
   
    switch (type) {
        case actionType.FET_MOVIE_HOME_REQUEST:
            return { ...state, loading: true };

        case actionType.FET_MOVIE_HOME:
            return { ...state, Movie: payload?.data, loading: false };

        case actionType.FET_MOVIE_HOME_FAILED:
            return { ...state, ErrorMessage: payload }
        default:
            return state;
    }
}
// detail movie
export const DetailMovie = (state = initMovie, { type, payload }) => {
    console.log("Reduser",type);
    switch (type) {
        case actionType.SELECTED_MOVIES_REQUEST:
            return { ...state, loading: true };

        case actionType.SELECTED_MOVIES:
            return { ...state, MovieDetail: payload?.data?.movie, loading: false, header: true };

        case actionType.SELECTED_FAILED:
            return { ...state, ErrorMessage: payload }

        case actionType.REMOVE_MOVIE:
            return { header: false }
        default:
            return state;
    }
}
// Similar Movies
export const SimilarMovies = (state = initMovie, { type, payload }) => {
    switch (type) {
        case actionType.SIMILAR_MOVIES_REQUEST:
            return { ...state, loading: true };

        case actionType.SIMILAR_MOVIES_SUCCESS:
            return { ...state, SimilarMV: payload?.data?.movies, loading: false };

        case actionType.SIMILAR_MOVIES_FAILED:
            return { ...state, ErrorMessage: payload }

        default:
            return state;
    }
}
// Catagories
export const FetCatagory = (state = initMovie, { type, payload }) => {
    switch (type) {
        case actionType.FET_GENRE_REQUEST:
            return { ...state, loading: true };
        case actionType.FET_GENRE:
            return { ...state, Catagory: payload?.data?.movies, loading: false };
        case actionType.FET_GENRE_FAILED:
            return { ...state, ErrorMessage: payload }
        default:
            return state;
    }
}
// search movie
export const SearchMV = (state = initMovie, { type, payload }) => {
    switch (type) {
        case actionType.SEARCH_MOVIES_REQUEST:
            return { ...state, LoadingSearch: true };

        case actionType.SEARCH_MOVIES:
            return { ...state, searchMV: payload?.data.movies, LoadingSearch: false };

        case actionType.SELECTED_FAILED:
            return { ...state, ErrorMessage: payload }
        default:
            return state;
    }
}
// Browse Movies
export const fetbrowseMovies = (state = initMovie, { type, payload }) => {
    switch (type) {
        case actionType.BROWSE_MOVIES_REQUEST:
            return { ...state, LoadingBrowse: true };

        case actionType.BROWSE_MOVIES_SUCCESS:
            return { ...state, browserMovies: payload?.data?.movies, LoadingBrowse: false };

        case actionType.BROWSE_MOVIES_REMOVE:
            return { browserMovies: [] }

        case actionType.BROWSE_MOVIES_FAILED:
            return { ...state, ErrorMessage: payload }

        default:
            return state;
    }
}